@file:OptIn(ExperimentalJsExport::class)
@file:JsExport

package components

import game.GameEngine
import game.gameStore
import react.FC
import react.dom.html.ReactHTML.div
import react.useEffectOnce
import react.useRef
import web.cssom.ClassName
import web.html.HTMLDivElement

// 引擎实例(模块级,避免在组件重建时重复创建)
private var engineInstance: GameEngine? = null

/**
 * 游戏主组件:承载 THREE.js 画布 + HUD 覆盖层
 */
val GameApp = FC("GameApp") {
    val containerRef = useRef<HTMLDivElement>(null)

    useEffectOnce {
        val container = containerRef.current ?: return@useEffectOnce

        // 初始化 THREE 引擎
        val engine = engineInstance ?: GameEngine(container).also { engineInstance = it }
        engine.buildObstacles(gameStore.getState().obstacles)
        engine.attachKeyListeners()
        engine.attachMouseListeners()
        engine.start()

        // 窗口大小变化时重设渲染尺寸
        val win: dynamic = js("window")
        win.addEventListener("resize") {
            engine.resize()
        }
    }

    div {
        className = ClassName("game-root")
        div {
            ref = containerRef
            className = ClassName("game-canvas")
        }
        GameHud()
        DebugPanel()
    }
}
